export default __webpack_public_path__ + "static/media/bar.98432c1b.png";